import React, { useState, useEffect, useRef } from "react";
import { Editor, EditorState, ContentState, convertToRaw } from "draft-js";
import "draft-js/dist/Draft.css";
import "../../_css/cms.css";
import { getCMS, putCMS } from "../../requests";
import { notifyError, notifySuccess } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import Empty from "../common/Empty";
import RichTextEditor from "../common/RichTextEditor";





export default function EachcmsUI({ slug, draft }) {
  const imgRef1 = useRef(null);
  const imgRef2 = useRef(null);
  const imgRef3 = useRef(null);

  const dispatch = useDispatch();
  const [sections, setSections] = useState([]);
  const [files, setFiles] = useState([]);
  const [nothingToEdit, setNothingToEdit] = useState(false);

  const [descAr, setDescAr] = useState("");

  // Fetch data from API
  useEffect(() => {
    async function fetchData() {
      try {
        let data = [];

        dispatch(startLoader());

        if (draft) {
          const response = await getCMS({ slug: slug, status: 0 });
          data = response.data.content;
        } else {
          const response = await getCMS({ slug: slug, status: 1 });
          data = response.data.content;
        }

        const formattedSections = data?.map((item) => ({
          title: item.title || "",
          desc: item.desc
            ? EditorState.createWithContent(
                ContentState.createFromText(item.desc)
              )
            : EditorState.createEmpty(),
          img: item.img || "",
        }));

        setSections(
          formattedSections.length
            ? formattedSections
            : [{ title: "", desc: EditorState.createEmpty(), img: "" }]
        );
      } catch (err) {
        console.error(err);
        setSections([{ title: "", desc: EditorState.createEmpty(), img: "" }]);
        setNothingToEdit(true);
      } finally {
        dispatch(stopLoader());
      }
    }

    fetchData();
  }, []);

  // Add new section
  const addSection = () => {
    setSections([...sections, { title: "", desc: EditorState.createEmpty()}]);
  };

  // Update a section field
  const updateSection = (index, field, value) => {
    const newSections = [...sections];
    newSections[index][field] = value;
    setSections(newSections);
  };

  // Delete a section
  const deleteSection = (index) => {
    setSections(sections.filter((_, i) => i !== index));
  };

  // Save sections (convert desc to JSON)
  const handleSave = async (s) => {
    //save text data in desc
    const data = sections
      .map((section) => ({
        title: section.title,
        desc: convertToRaw(section.desc.getCurrentContent()).blocks[0].text, // Draft.js JSON
        img: section.img,
      }));

    if (data.length == 0) {
      notifyError("Please enter some content");
      return;
    }

    dispatch(startLoader());

    try {
      const formData = new FormData();
      formData.append("slug", slug);
      formData.append("content", JSON.stringify(data));
      formData.append("status", s);
      files.forEach((file, i) => {
        formData.append(`images`, file);
      });

    



      const response = await putCMS(formData);

      if (response.status < 400) {
        notifySuccess("Saved Successfully");
      }
    } catch (error) {
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
  };
  const handleFileChange = (e, i) => {

    if(!sections[i]){
      notifyError(`Please enter some content for  section ${(i+1)}  before uploading image`);
      return;
    }
    setFiles((p) => {
      let arr = [...p];
      arr[i] = e.target.files[0];
      return arr;
    });

    //add image to same index in sections

   
  

    setSections((p) => {
      let arr = [...p];
      arr[i].img = e.target.files[0].name;
      return arr;
    });
    
  };

  if (nothingToEdit)
    return <Empty content="You have not saved any draft yet..." />;


  return (
    <div className="tm-main">
      <div className="overview-head">
        <div className="overview-head-left">
          {draft ? slug + " Draft " : slug}
        </div>
        <div className="overview-head-right">
          <button
            className="my-btn"
            style={{ backgroundColor: "#E0F5FE", color: "#01A7DE" }}
            onClick={() => handleSave(0)}
          >
            {" "}
            Save as draft
          </button>
          <button className="my-btn" onClick={() => handleSave(1)}>
            Publish
          </button>
        </div>
      </div>
      {slug == "About Us" && (
        <div className="each-cms-img-con">
          <input
            type="file"
            onChange={(e) => handleFileChange(e, 0)}
            ref={imgRef1}
            style={{ display: "none" }}
          />
          <div
            className="each-cms-img pe-cursor"
            onClick={() => imgRef1.current.click()}
          >
            {files[0]?.name || "Upload image 1"}
          </div>

          <input
            type="file"
            onChange={(e) => handleFileChange(e, 1)}
            ref={imgRef2}
            style={{ display: "none" }}
          />
          <div
            className="each-cms-img pe-cursor"
            onClick={() => imgRef2.current.click()}
          >
            {files[1]?.name || "Upload image 2"}
          </div>

          <input
            type="file"
            onChange={(e) => handleFileChange(e, 2)}
            ref={imgRef3}
            style={{ display: "none" }}
          />
          <div
            className="each-cms-img pe-cursor"
            onClick={() => imgRef3.current.click()}
          >
            {files[2]?.name || "Upload image 3"}
          </div>
        </div>
      )}

      <div className="each-cms-main">
        {sections.map((section, index) => (
          <div
            key={index}
            style={{
              marginBottom: "20px",
              padding: "10px",
              position: "relative",
            }}
          >
            {/* Delete button */}
            <button
              onClick={() => deleteSection(index)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "#01A7DE",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "25px",
                height: "25px",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            {/* Title input */}
            <input
              type="text"
              placeholder="Title"
              value={section.title}
              onChange={(e) => updateSection(index, "title", e.target.value)}
              className="each-cms-input"
            />

            {/* Draft.js editor for description */}
            <div
              style={{
                paddingLeft: "12px",
                marginBottom: "10px",
              }}
            >
              <Editor
                editorState={section.desc}
                onChange={(state) => updateSection(index, "desc", state)}
                placeholder="Type description here..."
                className="each-cms-desc"
              />
            </div>
           
          </div>
        ))}

        <button
          onClick={addSection}
          style={{
            width: "fit-content",
            backgroundColor: "#E0F5FE",
            color: "#01A7DE",
          }}
          className="my-btn"
        >
          + Add
        </button>
      </div>
    </div>
  );
}
